module.exports = __webpack_public_path__ + "static/media/Sekundarlogo-2.70a254aa.png";